import { MenuItemProps } from '@mui/material/MenuItem'
import MenuItemText from './Text'
import MenuItemCheckbox from './Checkbox'
import MenuItemToggle from './Toggle'
import MenuItemCheckboxAccordion from './CheckboxAccordion'
import MenuItemDropdown from './Dropdown'
import MenuItemTitle from './Title'
import MenuItemDivider from './Divider'
import MenuItemSearch from './Search'
import MenuItemImg from './Img'

export type MenuItemSize = 'm' | 's'

export interface BaseMenuItemProps extends Omit<MenuItemProps, 'disabled'> {
    size?: MenuItemSize
    isDisabled?: boolean
    className?: string
    tooltipContext?: { title?: string; label?: string }
}

const MenuItem = {
    Title: MenuItemTitle,
    Divider: MenuItemDivider,
    Text: MenuItemText,
    Checkbox: MenuItemCheckbox,
    Toggle: MenuItemToggle,
    CheckboxAccordion: MenuItemCheckboxAccordion,
    Dropdown: MenuItemDropdown,
    Search: MenuItemSearch,
    Img: MenuItemImg,
}

export default MenuItem
